import React, { Component } from "react";

export default class SignUp extends Component {
  render() {
    return (
      <form>
        <h3>Register</h3>

        <div className="form-group">
          <label>Hospital Name</label>
          <input
            type="text"
            className="form-control"
            placeholder="Hospital Name"
          />
        </div>

        <div className="form-group">
          <label> State </label>
          <input type="text" className="form-control" placeholder=" State" />
        </div>

        <div className="form-group">
          <label>Hospital Address</label>
          <input
            type="text"
            className="form-control"
            placeholder="Hospital Address"
          />
        </div>

        <div className="form-group">
          <label> Beds Occupied </label>
          <input
            type="number"
            className="form-control"
            placeholder="Beds Occupied"
          />
        </div>

        <div className="form-group">
          <label> Total Beds </label>
          <input
            type="text"
            className="form-control"
            placeholder="Total Beds"
          />
        </div>

        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            className="form-control"
            placeholder="Enter password"
          />
        </div>

        <button type="submit" className="btn btn-dark btn-lg btn-block">
          Register
        </button>
        <p className="forgot-password text-right">
          Already registered <a href="#">log in?</a>
        </p>
      </form>
    );
  }
}
